<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timer = null;
    this.requestSeq = 0;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (this.destroyed) {
        return;
      }

      this.geocoder = geocoder

      if (this.value.value) {
        this.items.push(this.value);
        this.select = this.value;
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.invalidate();
  },

  watch: {
    search(val) {
      if (!val) {
        this.invalidate();
        this.items = this.select && typeof this.select === "object" ? [this.select] : [];
        return;
      }

      if (!this.isSelectedText(val)) {
        this.querySelections(val);
      }
    }
  },

  methods: {
    invalidate() {
      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.requestSeq++;
      this.loading = false;
    },

    isSelectedText(val) {
      if (this.select && typeof this.select === "object") {
        return val === this.select.text;
      }

      return val === this.select;
    },

    querySelections(value) {
      this.invalidate();

      const seq = this.requestSeq;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        if (!this.geocoder || seq !== this.requestSeq) {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
          return;
        }

        this.geocoder.autocomplete(value).then(items => {
          if (seq === this.requestSeq) {
            this.items = items.slice();
          }
        }, () => {
          if (seq === this.requestSeq) {
            this.items = [];
          }
        }).then(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.invalidate();

      if (o && typeof o === "object") {
        this.items = [o];
      }

      this.$emit("change", o);
    }
  }
};
</script>
